import React, { useEffect, useState } from "react"

import { Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap"

import { connect } from "react-redux";
import { useDispatch } from 'react-redux';
import Select from "react-select"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import { toast } from "react-toastify";
import { createStudent, uploadStudents } from "helpers/student_helper";
import Loader from "components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import { fetchAllBatch } from "helpers/batch_helper";


const CreateSingleStudent = (props) => {
    document.title = "Student Management | Create Single Student";
    const [spanDisplay, setSpanDisplay] = useState("none");

    const [loader, setLoader] = useState(false);

    const navigate = useNavigate();

    const [studentDetails, setStudentDetails] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        batchDto: null,
        tataStudentDetailsDto: {
            division: '',
            contractorName: '',
            contractorTokenNo: '',
            aadhaarNo: '',
            dateOfService: '',
            lastAttendDate: '',
            driverDlNo: '',
            driverBadgeNo: '',
            natureOfWork: '',
            state: '',
            project: '',
            licenceValidityDate: '',
        }


    });
    const [allBatch, setAllBatch] = useState([]);
    const [batch, setBatch] = useState(null);

    const breadcrumbItems = [
        { title: "Students", link: "#" },
        { title: "Create Single Student", link: "#" },
    ]
    useEffect(() => {           /* For closing the sidebar if opened */
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])



    useEffect(() => {
        props.setBreadcrumbItems('Create Student', breadcrumbItems)
    })

    const [organizationId, setOrganizationId] = useState(null);
    useEffect(() => {
        let a = JSON.parse(localStorage.getItem("authUser"));
        setOrganizationId(a.organizationId);

    }, []);

    const getAllBatches = async () => {
        try {
            setLoader(true);
            const result = await fetchAllBatch();
            if (result?.success) {
                setAllBatch(result?.result);
            }
            else {
                toast.error(result?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoader(false);
        }

    }


    useEffect(() => {
        getAllBatches();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("1")

        // Regular expression for validating mobile number (example: 10 digits)
        const mobileRegex = /^\d{10}$/; // Adjust the regex as per your mobile number format requirements

        // Check for empty fields
        if (!studentDetails.firstName || !studentDetails.lastName || !studentDetails.email || !studentDetails.mobile
        ) {
            setSpanDisplay("inline");
            return; // Exit early if any field is empty
        }

        if (organizationId == 2) {
            if (!studentDetails.tataStudentDetailsDto.division || !studentDetails.tataStudentDetailsDto.contractorName ||
                !studentDetails.tataStudentDetailsDto.contractorTokenNo || !studentDetails.tataStudentDetailsDto.aadhaarNo ||
                !studentDetails.tataStudentDetailsDto.dateOfService || !studentDetails.tataStudentDetailsDto.lastAttendDate ||
                !studentDetails.tataStudentDetailsDto.driverDlNo || !studentDetails.tataStudentDetailsDto.driverBadgeNo ||
                !studentDetails.tataStudentDetailsDto.natureOfWork || !studentDetails.tataStudentDetailsDto.state ||
                !studentDetails.tataStudentDetailsDto.project || !studentDetails.tataStudentDetailsDto.licenceValidityDate
            ) {
                setSpanDisplay("inline");
                return;
            }
        }

        console.log("2")
        // Validate mobile number
        if (!mobileRegex.test(studentDetails.mobile)) {
            toast.error("Please enter a valid mobile number (10 digits).");
            return; // Exit early if the mobile number is invalid
        }

        console.log("3")
        setLoader(true);
        try {
            const data = await createStudent(studentDetails);
            if (data?.success) {
                toast.success(data?.message);
                setStudentDetails({
                    firstName: '',
                    lastName: '',
                    email: '',
                    mobile: '',
                    batchDto: null,
                    tataStudentDetailsDto: {
                        division: '',
                        contractorName: '',
                        contractorTokenNo: '',
                        aadhaarNo: '',
                        dateOfService: '',
                        lastAttendDate: '',
                        driverDlNo: '',
                        driverBadgeNo: '',
                        natureOfWork: '',
                        state: '',
                        project: '',
                        licenceValidityDate: '',
                    }
                });
                setSpanDisplay("block");
                setBatch(null);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const handleBatchChange = (selectedValue) => {
        setBatch(selectedValue);
        setStudentDetails(prevDetails => ({
            ...prevDetails,
            batchDto: selectedValue
        }))
    }

    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row>

                <Col>
                    <Card>
                        <CardBody className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12">
                            {/* <CardBody className="" style={{ minHeight: "70vh", }}> */}

                            <div className="d-flex justify-content-between mb-5">

                                <CardTitle className="h4">Create Student</CardTitle>
                            </div>

                            <form onSubmit={handleSubmit}>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        First Name
                                    </label>
                                    <div className="col-md-10">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter First Name"
                                            value={studentDetails.firstName} // bind to studentDetails.firstName
                                            maxLength="50"
                                            onChange={(e) => setStudentDetails(prevDetails => ({
                                                ...prevDetails,
                                                firstName: e.target.value // update the firstName field
                                            }))}
                                        />
                                        {!studentDetails.firstName && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                    </div>
                                </Row>
                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Last Name
                                    </label>
                                    <div className="col-md-10">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Last Name"
                                            value={studentDetails.lastName}
                                            maxLength="50"
                                            onChange={(e) => setStudentDetails(prevDetails => ({
                                                ...prevDetails,
                                                lastName: e.target.value
                                            }))}
                                        />
                                        {!studentDetails.lastName && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                    </div>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Email
                                    </label>
                                    <div className="col-md-10">
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Enter Email"
                                            value={studentDetails.email}
                                            maxLength="100"
                                            onChange={(e) => setStudentDetails(prevDetails => ({
                                                ...prevDetails,
                                                email: e.target.value
                                            }))}
                                        />
                                        {!studentDetails.email && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                    </div>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Mobile
                                    </label>
                                    <div className="col-md-10">
                                        <input
                                            type="tel"
                                            className="form-control"
                                            placeholder="Enter Mobile Number"
                                            value={studentDetails.mobile}
                                            maxLength="15"
                                            onChange={(e) => setStudentDetails(prevDetails => ({
                                                ...prevDetails,
                                                mobile: e.target.value
                                            }))}
                                        />
                                        {!studentDetails.mobile && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                    </div>
                                </Row>
                                {organizationId != 2 &&
                                    <Row className="mb-3">
                                        <label
                                            htmlFor="example-text-input"
                                            className="col-md-2 col-form-label"
                                        >
                                            Batch
                                        </label>
                                        <div className="col-md-10">

                                            <Select

                                                value={batch}
                                                onChange={handleBatchChange}
                                                options={allBatch}
                                                getOptionLabel={option => option.batchName}
                                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Row>
                                }
                                {organizationId == 2 &&
                                    <>
                                        <Row className="mb-3">
                                            <label className="col-md-2 col-form-label">Division</label>
                                            <div className="col-md-10">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Division"
                                                    value={studentDetails.tataStudentDetailsDto.division}
                                                    maxLength="50"
                                                    onChange={(e) =>
                                                        setStudentDetails(prev => ({
                                                            ...prev,
                                                            tataStudentDetailsDto: {
                                                                ...prev.tataStudentDetailsDto,
                                                                division: e.target.value,
                                                            },
                                                        }))
                                                    }
                                                />
                                                {!studentDetails.tataStudentDetailsDto.division && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                            </div>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-2 col-form-label">Contractor Name</label>
                                            <div className="col-md-10">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Contractor Name"
                                                    value={studentDetails.tataStudentDetailsDto.contractorName}
                                                    maxLength="50"
                                                    onChange={(e) =>
                                                        setStudentDetails(prev => ({
                                                            ...prev,
                                                            tataStudentDetailsDto: {
                                                                ...prev.tataStudentDetailsDto,
                                                                contractorName: e.target.value,
                                                            },
                                                        }))
                                                    }
                                                />
                                                {!studentDetails.tataStudentDetailsDto.contractorName && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                            </div>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-2 col-form-label">Contractor Token No</label>
                                            <div className="col-md-10">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Contractor Token No"
                                                    value={studentDetails.tataStudentDetailsDto.contractorTokenNo}
                                                    onChange={(e) =>
                                                        setStudentDetails(prev => ({
                                                            ...prev,
                                                            tataStudentDetailsDto: {
                                                                ...prev.tataStudentDetailsDto,
                                                                contractorTokenNo: e.target.value,
                                                            },
                                                        }))
                                                    }
                                                />
                                                {!studentDetails.tataStudentDetailsDto.contractorTokenNo && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                            </div>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-2 col-form-label">Aadhaar No</label>
                                            <div className="col-md-10">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Aadhaar No"
                                                    value={studentDetails.tataStudentDetailsDto.aadhaarNo}
                                                    maxLength="12"
                                                    onChange={(e) =>
                                                        setStudentDetails(prev => ({
                                                            ...prev,
                                                            tataStudentDetailsDto: {
                                                                ...prev.tataStudentDetailsDto,
                                                                aadhaarNo: e.target.value,
                                                            },
                                                        }))
                                                    }
                                                />
                                                {!studentDetails.tataStudentDetailsDto.aadhaarNo && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                            </div>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-2 col-form-label">Date of Service</label>
                                            <div className="col-md-10">
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={studentDetails.tataStudentDetailsDto.dateOfService}
                                                    onChange={(e) =>
                                                        setStudentDetails(prev => ({
                                                            ...prev,
                                                            tataStudentDetailsDto: {
                                                                ...prev.tataStudentDetailsDto,
                                                                dateOfService: e.target.value,
                                                            },
                                                        }))
                                                    }
                                                />
                                                {!studentDetails.tataStudentDetailsDto.dateOfService && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                            </div>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-2 col-form-label">Last Attend Date</label>
                                            <div className="col-md-10">
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={studentDetails.tataStudentDetailsDto.lastAttendDate}
                                                    onChange={(e) =>
                                                        setStudentDetails(prev => ({
                                                            ...prev,
                                                            tataStudentDetailsDto: {
                                                                ...prev.tataStudentDetailsDto,
                                                                lastAttendDate: e.target.value,
                                                            },
                                                        }))
                                                    }
                                                />
                                                {!studentDetails.tataStudentDetailsDto.lastAttendDate && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                            </div>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-2 col-form-label">Driver DL No</label>
                                            <div className="col-md-10">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Driver DL No"
                                                    value={studentDetails.tataStudentDetailsDto.driverDlNo}
                                                    onChange={(e) =>
                                                        setStudentDetails(prev => ({
                                                            ...prev,
                                                            tataStudentDetailsDto: {
                                                                ...prev.tataStudentDetailsDto,
                                                                driverDlNo: e.target.value,
                                                            },
                                                        }))
                                                    }
                                                />
                                                {!studentDetails.tataStudentDetailsDto.driverDlNo && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                            </div>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-2 col-form-label">Driver Badge No</label>
                                            <div className="col-md-10">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Driver Badge No"
                                                    value={studentDetails.tataStudentDetailsDto.driverBadgeNo}
                                                    onChange={(e) =>
                                                        setStudentDetails(prev => ({
                                                            ...prev,
                                                            tataStudentDetailsDto: {
                                                                ...prev.tataStudentDetailsDto,
                                                                driverBadgeNo: e.target.value,
                                                            },
                                                        }))
                                                    }
                                                />
                                                {!studentDetails.tataStudentDetailsDto.driverBadgeNo && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                            </div>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-2 col-form-label">Nature of Work</label>
                                            <div className="col-md-10">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Nature of Work"
                                                    value={studentDetails.tataStudentDetailsDto.natureOfWork}
                                                    onChange={(e) =>
                                                        setStudentDetails(prev => ({
                                                            ...prev,
                                                            tataStudentDetailsDto: {
                                                                ...prev.tataStudentDetailsDto,
                                                                natureOfWork: e.target.value,
                                                            },
                                                        }))
                                                    }
                                                />
                                                {!studentDetails.tataStudentDetailsDto.natureOfWork && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                            </div>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-2 col-form-label">State</label>
                                            <div className="col-md-10">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter State"
                                                    value={studentDetails.tataStudentDetailsDto.state}
                                                    onChange={(e) =>
                                                        setStudentDetails(prev => ({
                                                            ...prev,
                                                            tataStudentDetailsDto: {
                                                                ...prev.tataStudentDetailsDto,
                                                                state: e.target.value,
                                                            },
                                                        }))
                                                    }
                                                />
                                                {!studentDetails.tataStudentDetailsDto.state && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                            </div>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-2 col-form-label">Project</label>
                                            <div className="col-md-10">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Project"
                                                    value={studentDetails.tataStudentDetailsDto.project}
                                                    onChange={(e) =>
                                                        setStudentDetails(prev => ({
                                                            ...prev,
                                                            tataStudentDetailsDto: {
                                                                ...prev.tataStudentDetailsDto,
                                                                project: e.target.value,
                                                            },
                                                        }))
                                                    }
                                                />
                                                {!studentDetails.tataStudentDetailsDto.project && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                            </div>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-2 col-form-label">Licence Validity Date</label>
                                            <div className="col-md-10">
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={studentDetails.tataStudentDetailsDto.licenceValidityDate}
                                                    onChange={(e) =>
                                                        setStudentDetails(prev => ({
                                                            ...prev,
                                                            tataStudentDetailsDto: {
                                                                ...prev.tataStudentDetailsDto,
                                                                licenceValidityDate: e.target.value,
                                                            },
                                                        }))
                                                    }
                                                />
                                                {!studentDetails.tataStudentDetailsDto.licenceValidityDate && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                            </div>
                                        </Row>
                                    </>
                                }

                                <Row className="mb-3">
                                    <div className="mt-4">
                                        <button type="submit" className="btn btn-primary w-md">Submit</button>
                                    </div>
                                </Row>
                            </form>

                        </CardBody>
                    </Card>
                </Col>
            </Row>



        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(CreateSingleStudent);